export default {
  props: {
    title: String,
    text: String
  },
  data: () => ({
    toggle: false
  })
}
